/* ============================================================================
FILE: po-natirel-poezi-collection-fr-en-es-20260727.js
ROLE: Description trilingue protégée de la collection « Natirèl poézi ».
ROOT: [data-po-natirel-poezi]
LANGUES: FR / EN / ES
STORAGE: po_lex_lang + goody_gp_lang
AUDIO: SpeechSynthesis, lecture du texte actif uniquement.
LIENS: Natirèl poézi + RéZonans.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_NATIREL_POEZI_COLLECTION_20260727__) return;
  window.__PO_NATIREL_POEZI_COLLECTION_20260727__ = true;

  var ROOT_SELECTOR = "[data-po-natirel-poezi]";
  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis)
    ? window.speechSynthesis
    : null;

  var AUDIO_STATE = {
    root: null,
    chunks: [],
    index: 0,
    active: false
  };

  function clampStr(value){
    return value == null ? "" : String(value);
  }

  function escapeHTML(value){
    return clampStr(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  var CANONICAL_LINKS = {
    collection: "/collections/natirel-poezi",
    rezonans: "/pages/rezonans"
  };

  function pageLink(value, href, isCanonical){
    var classes = "po-natirel-collection__link";

    if (isCanonical) {
      classes += " po-natirel-collection__canonical notranslate";
    }

    return '<a class="' + classes + '"' +
      (isCanonical ? ' translate="no"' : "") +
      ' href="' + escapeHTML(href) + '">' +
      escapeHTML(value) +
      "</a>";
  }

  function canonical(value, href){
    if (href) return pageLink(value, href, true);

    return '<span class="po-natirel-collection__canonical notranslate" translate="no">' +
      escapeHTML(value) +
      "</span>";
  }

  var CANON = {
    title: canonical(
      "Natirèl poézi",
      CANONICAL_LINKS.collection
    ),
    rezonans: canonical(
      "RéZonans",
      CANONICAL_LINKS.rezonans
    ),
    hebertEdau: canonical("Hébert Edau")
  };

  var CONTENT = {
    fr: {
      ui: {
        group: "Choix de la langue",
        summary: "Description",
        audio: "Écouter",
        stop: "Arrêter",
        content: "Description de la collection Natirèl poézi"
      },
      paragraphs: [
        CANON.title + " se construit autour de mon amour de la nature, puis grandit au contact d’un projet porté par mon collègue et ami " + CANON.hebertEdau + ". Cette rencontre prolonge une relation artistique ancienne et ouvre dans ma pratique un espace d’attention renouvelée à ce qui vit autour de nous, à ce qui pousse, respire, bruisse, se déplace, se transforme et partage silencieusement nos territoires.",

        "La nature y apparaît comme un tissu vivant, localisé et territorialisé, composé de relations entre les sols, les végétaux, les animaux, les eaux, les vents, les lumières, les rythmes et les présences humaines. Chaque territoire possède sa manière particulière de respirer le monde. Il porte ses mémoires, ses fragilités, ses résistances, ses formes de croissance et les traces laissées par celles et ceux qui l’habitent.",

        "Dans " + CANON.title + ", l’humain partage l’espace avec une multitude de vivants et de phénomènes sensibles. Il avance au milieu des feuillages, des racines, des chants, des bruissements, des déplacements d’air et des variations de lumière. Cette proximité compose une expérience dans laquelle le regard rejoint l’écoute, le mouvement rencontre la matière et la couleur recueille les intensités du lieu.",

        "Les sons y deviennent des formes, les mouvements dessinent des lignes et les variations de l’environnement produisent une énergie particulière. Le frémissement d’une feuille, la tension d’une branche, la course d’un animal, la lente transformation d’un paysage ou la respiration d’une étendue d’eau participent à une même écriture du vivant. La peinture cherche alors à accueillir ces présences, à suivre leurs rythmes et à rendre perceptible ce qui circule entre elles.",

        "La collection parle également de notre manière d’habiter les territoires. Chaque présence humaine entre dans un réseau de relations déjà actif, où tout agit sur tout, où chaque déplacement modifie une proximité, une trajectoire, une lumière ou un équilibre. La nature devient ainsi partenaire de l’existence, mémoire des lieux et champ de " + CANON.rezonans + " entre l’individu, son environnement et les formes visibles ou plus discrètes qui l’accompagnent.",

        CANON.title + " ouvre enfin une expérience profondément spirituelle. La spiritualité y naît de l’attention accordée aux signes modestes, aux transformations lentes, aux souffles qui traversent le paysage et aux correspondances entre l’intime et le territoire. Elle se vit dans la proximité avec le vivant, dans la conscience d’appartenir à une trame plus vaste et dans cette sensation que chaque être, chaque matière et chaque énergie participent à une même poésie terrestre."
      ]
    },

    en: {
      ui: {
        group: "Language selection",
        summary: "Description",
        audio: "Listen",
        stop: "Stop",
        content: "Description of the Natirèl poézi collection"
      },
      paragraphs: [
        CANON.title + " is built around my love of nature, then grows through contact with a project developed by my colleague and friend " + CANON.hebertEdau + ". This encounter extends a longstanding artistic relationship and opens within my practice a renewed field of attention to what lives around us, to what grows, breathes, rustles, moves, transforms, and silently shares our territories.",

        "Nature appears here as a living, localised and territorialised fabric composed of relations among soils, plants, animals, waters, winds, lights, rhythms, and human presences. Each territory has its own way of breathing the world. It carries its memories, fragilities, resistances, forms of growth, and the traces left by those who inhabit it.",

        "Within " + CANON.title + ", the human shares space with a multitude of living beings and perceptible phenomena. The human moves among foliage, roots, songs, rustlings, currents of air, and variations of light. This proximity forms an experience in which sight joins listening, movement meets matter, and colour gathers the intensities of place.",

        "Sounds become forms, movements draw lines, and variations in the environment produce a particular energy. The trembling of a leaf, the tension of a branch, the movement of an animal, the slow transformation of a landscape, or the breathing of a body of water participate in the same writing of the living. Painting then seeks to welcome these presences, follow their rhythms, and make perceptible what circulates among them.",

        "The collection also speaks about the ways we inhabit territories. Every human presence enters an already active network of relations, where everything acts upon everything, where each movement alters a proximity, a trajectory, a light, or a balance. Nature thus becomes a partner of existence, a memory of places, and a field of " + CANON.rezonans + " between the individual, the environment, and the visible or more discreet forms that accompany them.",

        CANON.title + " finally opens a deeply spiritual experience. Spirituality arises from the attention granted to modest signs, slow transformations, breaths moving through the landscape, and correspondences between intimacy and territory. It is lived through proximity to the living, through the awareness of belonging to a broader fabric, and through the feeling that every being, every material, and every energy participates in the same earthly poetry."
      ]
    },

    es: {
      ui: {
        group: "Selección de idioma",
        summary: "Descripción",
        audio: "Escuchar",
        stop: "Detener",
        content: "Descripción de la colección Natirèl poézi"
      },
      paragraphs: [
        CANON.title + " se construye alrededor de mi amor por la naturaleza y crece después en contacto con un proyecto desarrollado por mi colega y amigo " + CANON.hebertEdau + ". Este encuentro prolonga una antigua relación artística y abre en mi práctica un espacio de atención renovada hacia aquello que vive a nuestro alrededor, hacia lo que crece, respira, susurra, se desplaza, se transforma y comparte silenciosamente nuestros territorios.",

        "La naturaleza aparece como un tejido vivo, localizado y territorializado, compuesto por relaciones entre los suelos, los vegetales, los animales, las aguas, los vientos, las luces, los ritmos y las presencias humanas. Cada territorio posee su manera particular de respirar el mundo. Lleva sus memorias, sus fragilidades, sus resistencias, sus formas de crecimiento y las huellas dejadas por quienes lo habitan.",

        "En " + CANON.title + ", el ser humano comparte el espacio con una multitud de seres vivos y fenómenos sensibles. Avanza entre follajes, raíces, cantos, susurros, desplazamientos de aire y variaciones de luz. Esta proximidad compone una experiencia en la que la mirada se une a la escucha, el movimiento encuentra la materia y el color recoge las intensidades del lugar.",

        "Los sonidos se convierten en formas, los movimientos dibujan líneas y las variaciones del entorno producen una energía particular. El temblor de una hoja, la tensión de una rama, la carrera de un animal, la lenta transformación de un paisaje o la respiración de una extensión de agua participan en una misma escritura de lo vivo. La pintura busca entonces acoger estas presencias, seguir sus ritmos y hacer perceptible aquello que circula entre ellas.",

        "La colección habla también de nuestra manera de habitar los territorios. Cada presencia humana entra en una red de relaciones ya activa, donde todo actúa sobre todo, donde cada desplazamiento modifica una proximidad, una trayectoria, una luz o un equilibrio. La naturaleza se convierte así en compañera de la existencia, memoria de los lugares y campo de " + CANON.rezonans + " entre el individuo, su entorno y las formas visibles o más discretas que lo acompañan.",

        CANON.title + " abre finalmente una experiencia profundamente espiritual. La espiritualidad nace de la atención concedida a los signos modestos, a las transformaciones lentas, a los soplos que atraviesan el paisaje y a las correspondencias entre lo íntimo y el territorio. Se vive en la proximidad con lo vivo, en la conciencia de pertenecer a una trama más amplia y en la sensación de que cada ser, cada materia y cada energía participan en una misma poesía terrestre."
      ]
    }
  };

  function normLang(raw){
    var value = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");

    if (value === "fr" || value.indexOf("fr-") === 0) return "fr";
    if (value === "en" || value.indexOf("en-") === 0) return "en";
    if (value === "es" || value.indexOf("es-") === 0) return "es";

    return "fr";
  }

  function readStoredLang(){
    var value = "";

    try {
      value = localStorage.getItem(STORAGE_KEY) || "";
    } catch(e) {
      value = "";
    }

    if (!value) {
      try {
        value = localStorage.getItem(STORAGE_KEY_COMPAT) || "";
      } catch(_e) {
        value = "";
      }
    }

    return value ? normLang(value) : "";
  }

  function getLang(){
    var stored = readStoredLang();
    var htmlLang = "";

    if (stored) return stored;

    try {
      htmlLang = document.documentElement.getAttribute("lang") || "";
    } catch(e) {
      htmlLang = "";
    }

    return htmlLang ? normLang(htmlLang) : "fr";
  }

  function storeLang(lang){
    var resolved = normLang(lang);

    try {
      localStorage.setItem(STORAGE_KEY, resolved);
    } catch(e) {}

    try {
      localStorage.setItem(STORAGE_KEY_COMPAT, resolved);
    } catch(_e) {}

    try {
      document.documentElement.setAttribute("lang", resolved);
    } catch(__e) {}

    return resolved;
  }

  function paragraphHTML(paragraphs){
    return paragraphs.map(function(paragraph){
      return '<p class="po-natirel-collection__paragraph">' +
        paragraph +
        "</p>";
    }).join("");
  }

  function updateButtons(root, lang){
    var buttons = root.querySelectorAll("[data-po-lang]");

    Array.prototype.forEach.call(buttons, function(button){
      var active = normLang(button.getAttribute("data-po-lang")) === lang;

      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updateUI(root, lang){
    var data = CONTENT[lang] || CONTENT.fr;
    var group = root.querySelector("[data-po-language-group]");
    var summaryLabel = root.querySelector("[data-po-summary-label]");
    var content = root.querySelector("[data-po-content]");
    var audio = root.querySelector("[data-po-audio]");

    root.setAttribute("lang", lang);
    root.setAttribute("aria-label", data.ui.content);

    if (group) group.setAttribute("aria-label", data.ui.group);
    if (summaryLabel) summaryLabel.textContent = data.ui.summary;
    if (content) content.setAttribute("aria-label", data.ui.content);

    if (audio) {
      audio.hidden = !AUDIO_SYNTH;
      audio.textContent = AUDIO_STATE.active && AUDIO_STATE.root === root
        ? data.ui.stop
        : data.ui.audio;
      audio.setAttribute(
        "aria-pressed",
        AUDIO_STATE.active && AUDIO_STATE.root === root ? "true" : "false"
      );
    }

    updateButtons(root, lang);
  }

  function renderRoot(root, lang){
    if (!root) return;

    var resolved = normLang(lang);
    var data = CONTENT[resolved] || CONTENT.fr;
    var content = root.querySelector("[data-po-content]");

    stopAudio();

    if (content) {
      content.classList.add("is-changing");

      window.setTimeout(function(){
        content.innerHTML = paragraphHTML(data.paragraphs);
        content.setAttribute("lang", resolved);
        content.classList.remove("is-changing");
      }, 80);
    }

    updateUI(root, resolved);
  }

  function applyLangEverywhere(lang){
    var resolved = normLang(lang);
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    Array.prototype.forEach.call(roots, function(root){
      renderRoot(root, resolved);
    });
  }

  function notifyLocaleChanged(lang){
    try {
      window.dispatchEvent(new CustomEvent("po:locale-changed", {
        detail: {
          lang: lang,
          source: "po-natirel-poezi-collection"
        }
      }));
    } catch(e) {
      try {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent("po:locale-changed", true, true, {
          lang: lang,
          source: "po-natirel-poezi-collection"
        });
        window.dispatchEvent(event);
      } catch(_e) {}
    }
  }

  function setLang(lang){
    var resolved = storeLang(lang);

    applyLangEverywhere(resolved);
    notifyLocaleChanged(resolved);

    return resolved;
  }

  function cleanAudioText(text){
    return clampStr(text)
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function splitAudioText(text, maxLength){
    var clean = cleanAudioText(text);
    var limit = maxLength || 210;
    var sentences;
    var chunks = [];
    var current = "";

    if (!clean) return chunks;

    sentences = clean.match(/[^.!?…]+[.!?…]+|[^.!?…]+$/g) || [clean];

    sentences.forEach(function(sentence){
      var part = sentence.trim();

      if (!part) return;

      if (part.length > limit) {
        var words = part.split(/\s+/);

        words.forEach(function(word){
          var candidate = current ? current + " " + word : word;

          if (candidate.length > limit && current) {
            chunks.push(current.trim());
            current = word;
          } else {
            current = candidate;
          }
        });

        return;
      }

      if ((current + " " + part).trim().length > limit && current) {
        chunks.push(current.trim());
        current = part;
      } else {
        current = (current + " " + part).trim();
      }
    });

    if (current) chunks.push(current.trim());

    return chunks;
  }

  function voiceFor(lang){
    if (!AUDIO_SYNTH || typeof AUDIO_SYNTH.getVoices !== "function") {
      return null;
    }

    var voices = AUDIO_SYNTH.getVoices() || [];
    var locale = lang === "en" ? "en" : (lang === "es" ? "es" : "fr");
    var exact = null;
    var partial = null;

    voices.some(function(voice){
      var code = clampStr(voice.lang).toLowerCase();

      if (!exact && code === locale) exact = voice;
      if (!partial && code.indexOf(locale + "-") === 0) partial = voice;

      return Boolean(exact);
    });

    return exact || partial || null;
  }

  function refreshAudioButtons(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      updateUI(root, lang);
    });
  }

  function resetAudioState(){
    AUDIO_STATE.root = null;
    AUDIO_STATE.chunks = [];
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = false;
    refreshAudioButtons();
  }

  function stopAudio(){
    if (AUDIO_SYNTH) {
      try {
        AUDIO_SYNTH.cancel();
      } catch(e) {}
    }

    resetAudioState();
  }

  function speakNext(){
    var root = AUDIO_STATE.root;
    var lang;
    var utterance;
    var voice;

    if (!AUDIO_SYNTH || !AUDIO_STATE.active || !root) {
      resetAudioState();
      return;
    }

    if (AUDIO_STATE.index >= AUDIO_STATE.chunks.length) {
      resetAudioState();
      return;
    }

    lang = normLang(root.getAttribute("lang") || getLang());
    utterance = new SpeechSynthesisUtterance(
      AUDIO_STATE.chunks[AUDIO_STATE.index]
    );
    voice = voiceFor(lang);

    utterance.lang = lang === "en"
      ? "en-US"
      : (lang === "es" ? "es-ES" : "fr-FR");
    utterance.rate = 0.94;
    utterance.pitch = 1;
    utterance.volume = 1;

    if (voice) utterance.voice = voice;

    utterance.onend = function(){
      AUDIO_STATE.index += 1;
      speakNext();
    };

    utterance.onerror = function(){
      resetAudioState();
    };

    AUDIO_SYNTH.speak(utterance);
  }

  function startAudio(root){
    var content;
    var text;

    if (!AUDIO_SYNTH || !root) return;

    if (AUDIO_STATE.active && AUDIO_STATE.root === root) {
      stopAudio();
      return;
    }

    stopAudio();

    content = root.querySelector("[data-po-content]");
    text = content ? content.textContent : "";

    AUDIO_STATE.root = root;
    AUDIO_STATE.chunks = splitAudioText(text, 210);
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = AUDIO_STATE.chunks.length > 0;

    refreshAudioButtons();

    if (AUDIO_STATE.active) speakNext();
  }

  function bindRoot(root){
    if (!root || root.getAttribute("data-po-bound") === "true") return;

    root.setAttribute("data-po-bound", "true");

    root.addEventListener("click", function(event){
      var langButton = event.target.closest("[data-po-lang]");
      var audioButton = event.target.closest("[data-po-audio]");

      if (langButton && root.contains(langButton)) {
        event.preventDefault();
        setLang(langButton.getAttribute("data-po-lang"));
        return;
      }

      if (audioButton && root.contains(audioButton)) {
        event.preventDefault();
        startAudio(root);
      }
    });
  }

  function initRoots(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      bindRoot(root);
      renderRoot(root, lang);
    });
  }

  window.addEventListener("po:locale-changed", function(event){
    var detail = event && event.detail ? event.detail : null;
    var lang = detail && detail.lang ? detail.lang : getLang();

    if (detail && detail.source === "po-natirel-poezi-collection") return;

    applyLangEverywhere(lang);
  });

  window.addEventListener("storage", function(event){
    if (!event) return;

    if (event.key === STORAGE_KEY || event.key === STORAGE_KEY_COMPAT) {
      applyLangEverywhere(event.newValue || getLang());
    }
  });

  document.addEventListener("shopify:section:load", function(){
    initRoots();
  });

  document.addEventListener("shopify:section:unload", function(){
    stopAudio();
  });

  window.addEventListener("pagehide", function(){
    stopAudio();
  });

  window.PoNatirelPoeziCollectionFR_EN_ES_20260727 = {
    getLang: getLang,
    setLang: setLang,
    init: initRoots,
    stopAudio: stopAudio
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRoots, { once: true });
  } else {
    initRoots();
  }
})();
